import PropTypes from 'prop-types';
import { Box } from '@mui/material';
const ListItemDot = ({ color }) => (
	<Box
		data-testid='list-item-dot'
		sx={{
			width: 8,
			height: 8,
			minWidth: 8,
			borderRadius: '50%',
			backgroundColor: color || 'signal.gray',
			mt: '5px',
			flexShrink: 0,
		}}
	/>
);

ListItemDot.propTypes = {
	color: PropTypes.string,
};

export default ListItemDot;
